// api/admins.js
import apiClient from './client';

export const adminApi = {
  // Get all admins
  getAll: () => apiClient.get('/admins'),
  
  // Create admin
  create: (data) => apiClient.post('/admins', data),
  
  // Delete admin
  delete: (id) => apiClient.delete(`/admins/${id}`),
  
  // Update admin
  update: (id, data) => apiClient.put(`/admins/${id}`, data),
};